import { TweenMax } from 'gsap';

const ShowcaseInitial = (element) => {
  TweenMax.set(element, { y: 100, autoAlpha: 0 });
};

export default ShowcaseInitial;
